import { Switch, Route, Router as WouterRouter } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/hooks/useTheme";
import NotFound from "@/pages/not-found";

import Home from "@/pages/index";
import Login from "@/pages/login";
import Signup from "@/pages/signup";
import SetPassword from "@/pages/set-password";
import ConfirmEmail from "@/pages/confirm-email";
import Me from "@/pages/me";
import Tournaments from "@/pages/tournaments";
import TournamentDetail from "@/pages/tournaments/[id]";
import Venues from "@/pages/venues";
import VenueDetail from "@/pages/venues/[id]";
import PublicPlayerProfile from "@/pages/players/[id]";
import Leaderboard from "@/pages/leaderboard";
import Results from "@/pages/results";
import VenueEmbed from "@/pages/embed/venue";
import Status from "@/pages/status";
import HostYourVenue from "@/pages/host-your-venue";

const queryClient = new QueryClient();

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/signup" component={Signup} />
      <Route path="/set-password" component={SetPassword} />
      <Route path="/confirm-email" component={ConfirmEmail} />
      <Route path="/me" component={Me} />
      <Route path="/tournaments" component={Tournaments} />
      <Route path="/tournaments/:id" component={TournamentDetail} />
      <Route path="/venues" component={Venues} />
      <Route path="/venues/:id" component={VenueDetail} />
      <Route path="/players/:id" component={PublicPlayerProfile} />
      <Route path="/leaderboard" component={Leaderboard} />
      <Route path="/results" component={Results} />
      <Route path="/embed/venue/:id" component={VenueEmbed} />
      <Route path="/status" component={Status} />
      <Route path="/host-your-venue" component={HostYourVenue} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, "")}>
            <Router />
          </WouterRouter>
          <Toaster />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
